module.exports = require("@splunk/react-ui/Table");